export default "__VITE_ASSET__CpU5_OkL__"